/* RESPONSIBLE TEAM: team-actions */
import RulesetLinkSerializer from '../ruleset-link';

export default RulesetLinkSerializer;
